/*
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2024-03-21 14:08:10
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2024-03-21 14:08:19
 * FilePath     :\AV-COM-user-backend\src\utils\type-map.js
 * RevisionHistory:
 */
export const roleMap = {
    0: "not",
    1: "manage",
    2: "view",
};
